













































import { brandContext } from '@/constants/locales';
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class MarketingCode extends Vue {
  @Prop() marketingCode!: string;
  @Prop() market?: string;
  @Prop() oscarConfigId?: string; // only set for brand Cupra

  locale(translationKey: string) {
    switch (brandContext) {
      case 'Volkswagen':
        return this.$t(`marketingCode.${translationKey}`);
      case 'Cupra':
        return this.$t(`marketingCode.${translationKey}`);
      default:
        return this.$t(`audiCode.${translationKey}`);
    }
  }
  get brandContext(): string {
    return brandContext;
  }

  get isMarketingCode(): boolean {
    return this.marketingCode.length === 8;
  }

  get hasCupraConfigId(): boolean {
    return this.oscarConfigId !== undefined && this.oscarConfigId.length > 0;
  }
}
